import { GeoInfoResponseBuilder } from './GeoInfoResponseBuilder';
import { AddressResponseBuilder } from './AddressResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class LocationResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Location');
    }
    public withId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['id'] = this.initField(null, args);
        return this;
    }

    public withGeo = (builder: GeoInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['geo'] = this.initField(builder, args);
        return this;
    }

    public withName = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['name'] = this.initField(null, args);
        return this;
    }

    public withAddress = (builder: AddressResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['address'] = this.initField(builder, args);
        return this;
    }

    public withLocationProvider = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['locationProvider'] = this.initField(null, args);
        return this;
    }

    public withProviderLocRef = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['providerLocRef'] = this.initField(null, args);
        return this;
    }
}
